// Mock data for Meraki Solutions portfolio
// All content here — easy to swap with backend later

export const siteMeta = {
  name: "Meraki Solutions",
  title: "Meraki Solutions — Cinematic Storytelling & Digital Engineering",
  description:
    "A multidisciplinary creative studio blending storytelling, branding, media, and digital innovation to build work that resonates. At Meraki Solutions, we believe the strongest brands are built through clarity, emotion, and experience. We bring together strategy, storytelling, design, media, and technology to create meaningful work that connects with people and leaves a lasting impact.",
  logo: "/meraki_solutions_logo.png",
  email: "info@meraki-solutions.in",
  phone: "+91 98275 55008",
  location: "26-B, Indrapuri, Bhopal, MP - 462021",
  coordinates: { lat: 23.2237882, lng: 77.4470877 },
  socials: {
    linkedin: "https://in.linkedin.com/company/merakisolutions1",
    instagram: "https://www.instagram.com/meraki_solutions/",
    website: "https://www.meraki-solutions.in",
    youtube: "#"
  }
};

export const navLinks = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Portfolio", href: "/portfolio" },
  { label: "Stack", href: "/stack" },
  {
    label: "Services",
    href: "/services",
    sublinks: [
      { label: "Branding", href: "/services/branding" },
      { label: "Film Making", href: "/services/film-making" },
      { label: "Video Editing", href: "/services/video-editing" },
      { label: "Motion Graphics", href: "/services/motion-graphics" },
      { label: "Web Development", href: "/services/web-development" },
      { label: "UI / UX Design", href: "/services/ui-ux-design" },
      { label: "Social Media", href: "/services/social-media" },
      // { label: "SEO & Performance", href: "/services/seo-performance" },
      { label: "Performance Marketing", href: "/services/performance-marketing" }
    ]
  },
  { label: "Careers", href: "/careers" },
  { label: "Contact", href: "/contact" }
];

export const footerLinks = {
  company: [
    { label: "About Us", href: "/about" },
    { label: "Careers", href: "/careers" },
    { label: "Contact", href: "/contact" },
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms & Conditions", href: "/terms" }
  ],
  services: [
    { label: "Branding", href: "/services/branding" },
    { label: "Film Making", href: "/services/film-making" },
    { label: "Web Development", href: "/services/web-development" },
    { label: "UI / UX Design", href: "/services/ui-ux-design" },
    { label: "Social Media", href: "/services/social-media" }
  ]
};

export const heroMarquee = [
  "Film Making",
  "Web Development",
  "Motion Graphics",
  "Branding",
  "UI / UX Design",
  "Video Editing",
  "Social Media",
  "Performance Marketing"
];

export const services = [
  {
    id: 1,
    category: "Film & Video",
    title: "Film Making",
    desc: "End-to-end film production — from storyboard to final grade. Narrative, commercial, documentary.",
    iconName: "Clapperboard",
    image: "https://images.unsplash.com/photo-1611540881474-bf7c8731bfd2?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: 2,
    category: "Film & Video",
    title: "Video Editing",
    desc: "Broadcast-grade editing, color grading, sound design. Trailers, reels, long-form.",
    iconName: "Film",
    image: "https://images.pexels.com/photos/257904/pexels-photo-257904.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 3,
    category: "Film & Video",
    title: "Motion Graphics",
    desc: "Kinetic typography, 2D/3D animations, title sequences that move hearts and eyeballs.",
    iconName: "Sparkles",
    image: "https://images.pexels.com/photos/414612/pexels-photo-414612.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 4,
    category: "Technology",
    title: "Web Development",
    desc: "Hand-crafted websites engineered for speed, SEO and conversion. React, Next.js, Headless CMS.",
    iconName: "Code2",
    image: "https://images.pexels.com/photos/1181263/pexels-photo-1181263.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 6,
    category: "Technology",
    title: "UI / UX Design",
    desc: "Human-centered interfaces. Research, wireframes, prototypes, design systems.",
    iconName: "PenTool",
    image: "https://images.pexels.com/photos/196644/pexels-photo-196644.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 7,
    category: "Brand & Growth",
    title: "Branding",
    desc: "Logos, identity systems, brand guidelines and tone of voice that stick.",
    iconName: "Layers",
    image: "https://images.pexels.com/photos/7661590/pexels-photo-7661590.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 8,
    category: "Brand & Growth",
    title: "Social Media",
    desc: "Content calendars, reels, community — we turn scroll into story.",
    iconName: "Share2",
    image: "https://images.pexels.com/photos/607812/pexels-photo-607812.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 9,
    category: "Brand & Growth",
    title: "Performance Marketing",
    desc: "Scale your customer acquisition. High-intent Meta Ads and Google Ads strategies built for measurable ROI.",
    iconName: "TrendingUp",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800"
  }
];

export const portfolio = [
  // --- WEBSITES (Genuine, from Web Development Page) ---
  {
    id: "p-web-1",
    title: "Lewana Hotel Dubai",
    category: "Websites",
    year: "2025",
    image: "/works/websites/lewanahoteldubai.png",
    url: "https://www.lewanahoteldubai.com/",
    size: "large",
    desc: "Luxury hotel booking portal built with Next.js & Serverless APIs."
  },
  {
    id: "p-web-2",
    title: "Cropflyt Technologies",
    category: "Websites",
    year: "2025",
    image: "/works/websites/croptflyt.png",
    url: "https://cropflyt.in/",
    size: "small",
    desc: "Interactive agricultural aviation platform utilizing headless React architecture."
  },
  {
    id: "p-web-3",
    title: "Claura Storefront",
    category: "Websites",
    year: "2024",
    image: "/works/websites/claura.png",
    url: "https://claura.in/",
    size: "large",
    desc: "Premium apparel e-commerce store with modular checkout flows."
  },
  {
    id: "p-web-4",
    title: "White Gloves Concierge",
    category: "Websites",
    year: "2024",
    image: "/works/websites/whitegloves.png",
    url: "https://www.whitegloves.in/",
    size: "small",
    desc: "High-end corporate cleaning service portal."
  },

  // --- BRANDING (Genuine, from Homepage/Branding) ---
  {
    id: "p-brand-1",
    title: "Nabhidhara Organic",
    category: "Branding",
    year: "2025",
    image: "/images/clients_logo/Nabhidhara Logo White.png",
    size: "small",
    desc: "Rustic visual system and ecosystem-inspired packaging."
  },
  {
    id: "p-brand-2",
    title: "Nakhrali Limited",
    category: "Branding",
    year: "2025",
    image: "/images/clients_logo/Nakhrali LIMITED EDITION Logo WHITE.png",
    size: "small",
    desc: "Luxury boutique typography and couture brand design."
  },
  {
    id: "p-brand-3",
    title: "Riyasat Organic Produce",
    category: "Branding",
    year: "2024",
    image: "/images/clients_logo/Riyasat Organic Logo White.png",
    size: "small",
    desc: "Heritage identity styling and visual positioning."
  },

  // --- CINEMATIC FILMS & FEATURED POSTERS ---
  {
    id: "p-film-1",
    title: "1930 — Cybercrime Awareness Short Film",
    category: "Films",
    year: "2026",
    image: "/images/films/1930-awards-poster.jpg",
    youtubeEmbedUrl: "https://www.youtube.com/embed/KAnKujVDjf4?autoplay=1&rel=0",
    size: "large",
    desc: "4x International Award Winner & 5 Official Selections. A gripping narrative inspired by true cybercrime events."
  },
  {
    id: "p-film-2",
    title: "Two Wombs, One Story",
    category: "Films",
    year: "2026",
    image: "/images/films/two-wombs-one-story-poster.jpg",
    size: "large",
    desc: "Vanitaa Vins presents A Baaton Mein Productions — Story by Chitra Katyal, Directed by Akshay Yagnik, Produced by Vanitaa Pande."
  },
  {
    id: "p-film-3",
    title: "Aurora — Short Film",
    category: "Films",
    year: "2025",
    image: "https://images.unsplash.com/photo-1611540881474-bf7c8731bfd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxjaW5lbWF0aWMlMjBmaWxtJTIwcHJvZHVjdGlvbnxlbnwwfHx8fDE3Nzc3MTA5MTR8MA&ixlib=rb-4.1.0&q=85",
    youtubeEmbedUrl: "https://www.youtube.com/embed/KAnKujVDjf4?autoplay=1&rel=0",
    size: "small",
    desc: "Noir visual drama and complex editing sequence."
  },

  // --- SOCIAL MEDIA POSTS & CAMPAIGN CHAPTERS ---
  {
    id: "p-social-1930",
    title: "1930 Film — Awards & Selections",
    category: "Social Media",
    year: "2026",
    image: "/images/films/1930-awards-poster.jpg",
    size: "large",
    desc: "Winner of Global India, Asian International Filmfare, Indian Movie Awards & Silver Wings. 5 Official Festival Selections."
  },
  {
    id: "p-social-twowombs",
    title: "Two Wombs, One Story — Poster",
    category: "Social Media",
    year: "2026",
    image: "/images/films/two-wombs-one-story-poster.jpg",
    size: "large",
    desc: "Vanitaa Vins presents A Baaton Mein Productions — Story by Chitra Katyal, Produced by Vanitaa Pande. Releasing 24th July."
  },
  {
    id: "p-social-1",
    title: "Vanitaa Pande Campaign",
    category: "Social Media",
    year: "2025",
    image: "/works/Social Media Posts/vanitaapande-post.png",
    size: "small",
    desc: "High-end luxury campaign post with custom editorial borders.",
    instagramUrl: "https://www.instagram.com/p/C31bZ-ySh3N/"
  },
  {
    id: "p-social-2",
    title: "Classic Motor",
    category: "Social Media",
    year: "2025",
    image: "/works/Social Media Posts/classic-motor-post.png",
    size: "small",
    desc: "Curation and styling layout for vintage automotive styling.",
    instagramUrl: "https://www.instagram.com/p/C33z3-JyS3M/"
  },
  {
    id: "p-social-3",
    title: "Gaagar Dairy & Sweets",
    category: "Social Media",
    year: "2025",
    image: "/works/Social Media Posts/gangan-post1.png",
    size: "small",
    desc: "Warm retail styling and aesthetic product layout.",
    instagramUrl: "https://www.instagram.com/p/C4A-B1JyR2K/"
  },
  {
    id: "p-social-4",
    title: "Vow Aesthetics Campaign",
    category: "Social Media",
    year: "2024",
    image: "/works/Social Media Posts/vow.aestheticswellness-post.png",
    size: "small",
    desc: "Luxury clinic branding layout and skin wellness styling.",
    instagramUrl: "https://www.instagram.com/p/C4F-G2LyF3B/"
  },
  {
    id: "p-social-5",
    title: "Saanvi Ethnicos Campaign",
    category: "Social Media",
    year: "2025",
    image: "/works/Social Media Posts/saanvi-ethnicos-post1.png",
    size: "small",
    desc: "Organic aesthetic styling and campaign feed layout.",
    instagramUrl: "https://www.instagram.com/p/C4R-H1MyK2A/"
  },
  {
    id: "p-social-6",
    title: "Sajwat Curation",
    category: "Social Media",
    year: "2025",
    image: "/works/Social Media Posts/sajwat-post.png",
    size: "small",
    desc: "Cinematic product curation and feed layouts.",
    instagramUrl: "https://www.instagram.com/p/C4U-L3JyR3A/"
  },
  {
    id: "p-social-7",
    title: "Flare by Blaze Feed",
    category: "Social Media",
    year: "2025",
    image: "/works/Social Media Posts/flarebyblaze-post1.png",
    size: "small",
    desc: "Vibrant high-contrast youth aesthetic product layouts.",
    instagramUrl: "https://www.instagram.com/p/C4X-O4MyL2P/"
  },
  {
    id: "p-social-8",
    title: "Classic Motor",
    category: "Social Media",
    year: "2025",
    image: "/works/Social Media Posts/classic-motor-post2.png",
    size: "small",
    desc: "Vintage typography overlays and automotive grid curation.",
    instagramUrl: "https://www.instagram.com/p/C4c-S2PyJ4E/"
  },

  // --- SUCCESS DIARIES (Curated from ClientFeedbackShowcase.jsx) ---
  {
    id: "p-sd-1",
    title: "Vanitaa Pande Testimonial",
    category: "Success Diaries",
    year: "2025",
    image: "https://img.youtube.com/vi/6BLuHegBaf0/maxresdefault.jpg",
    youtubeEmbedUrl: "https://www.youtube.com/embed/6BLuHegBaf0?autoplay=1&rel=0",
    size: "large",
    desc: "Vanitaa Pande talks about our high-end luxury cinematic campaigns and viral reach."
  },
  {
    id: "p-sd-2",
    title: "A Legacy Reborn in the Digital Era",
    category: "Success Diaries",
    year: "2025",
    image: "https://img.youtube.com/vi/MPnwGumdKVo/maxresdefault.jpg",
    youtubeEmbedUrl: "https://www.youtube.com/embed/MPnwGumdKVo?autoplay=1&rel=0",
    size: "small",
    desc: "How we took a legacy textile brand and engineered a high-speed React storefront, doubling digital orders within the first quarter."
  },
  {
    id: "p-sd-3",
    title: "Atlas Pictures Film Diary",
    category: "Success Diaries",
    year: "2025",
    image: "https://img.youtube.com/vi/ORUWmbu58RU/maxresdefault.jpg",
    youtubeEmbedUrl: "https://www.youtube.com/embed/ORUWmbu58RU?autoplay=1&rel=0",
    size: "large",
    desc: "Cinematic narrative features, sound engineering, and high-fidelity grading."
  },
  {
    id: "p-sd-4",
    title: "Kairos Labs UI Case",
    category: "Success Diaries",
    year: "2024",
    image: "https://img.youtube.com/vi/cUaRAYsC5q4/maxresdefault.jpg",
    youtubeEmbedUrl: "https://www.youtube.com/embed/cUaRAYsC5q4?autoplay=1&rel=0",
    size: "small",
    desc: "Series-A pitch web layouts and modern micro-animations."
  }
];

export const process = [
  {
    step: "01",
    title: "Listen & Understand",
    desc: "We sit with you, your team, your audience. We ask the hard questions before we open a single tool.",
    image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&q=80&w=1200"
  },
  {
    step: "02",
    title: "Research & Strategy",
    desc: "Market maps, competitor teardowns, mood boards and a written strategy document — your north star.",
    image: "https://images.unsplash.com/photo-1507537297725-24a1c029d3ca?auto=format&fit=crop&q=80&w=1200"
  },
  {
    step: "03",
    title: "Concept & Pre-production",
    desc: "Scripts, storyboards, wireframes, design systems. Everything is sketched before it is shot or shipped.",
    image: "https://images.unsplash.com/photo-1454165205744-3b78555e5572?auto=format&fit=crop&q=80&w=1200"
  },
  {
    step: "04",
    title: "Craft & Production",
    desc: "Cameras roll, code commits, frames animate. Our team collaborates in tight weekly sprints.",
    image: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&q=80&w=1200"
  },
  {
    step: "05",
    title: "Refine & Polish",
    desc: "Color grade, sound design, QA, performance tuning. We sweat every pixel and every millisecond.",
    image: "/images/refine-polish.png"
  },
  {
    step: "06",
    title: "Launch & Evolve",
    desc: "Premiere day. Go-live. And then — measure, iterate, scale. We stay till the work works.",
    image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=1200"
  }
];

export const stats = [
  { value: 120, suffix: "+", label: "Projects Delivered" },
  { value: 48, suffix: "", label: "Global Clients" },
  { value: 14, suffix: "+", label: "Years of Craft" },
  { value: 22, suffix: "", label: "Awards & Features" }
];

export const testimonials = [
  {
    id: 1,
    quote:
      "Chitra and her team don't just deliver work — they deliver belief. Our digital presence and reach transformed completely.",
    name: "Aarav Mehta",
    role: "Co-Founder, Croptflyt",
    bgImage: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&q=80&w=1200"
  },
  {
    id: 2,
    quote:
      "Rare combination of cinematic taste and engineering rigour. Our web revenue doubled six months after the relaunch.",
    name: "Priya Sharma",
    role: "Founder, Lewana",
    bgImage: "https://images.unsplash.com/photo-1512446816042-444d641267d4?auto=format&fit=crop&q=80&w=1200"
  },
  {
    id: 3,
    quote:
      "They make you feel like the only client in the room. Every frame, every line of code — handled with care.",
    name: "Vikram Iyer",
    role: "CMO, Saanvi",
    bgImage: "https://images.unsplash.com/photo-1542204172-658a4440c66e?auto=format&fit=crop&q=80&w=1200"
  },
  {
    id: 4,
    quote:
      "Meraki Solutions made our brand feel alive. The motion identity they built is still getting compliments a year later.",
    name: "Sara Qureshi",
    role: "Head of Brand, Gaagar",
    bgImage: "https://images.unsplash.com/photo-1550684848-fac1c5b4e853?auto=format&fit=crop&q=80&w=1200"
  }
];

export const founder = {
  name: "Chitra Katyal",
  role: "Brand Strategist & Storyteller",
  image:
    "https://media.licdn.com/dms/image/v2/D4D03AQECH9crhB0Skw/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1697109963998?e=2147483647&v=beta&t=wt7FV0xcWmjluYFtKCj4pL8XQSOtFR65zXt7QVjNRA8",
  linkedin: "https://in.linkedin.com/in/chitra-katyal-b5515b38",
  short:
    "Brand strategist, storyteller and founder of Meraki Solutions — bridging corporate strategy and narrative artistry for over a decade.",
  long: [
    "Chitra is a multi-disciplinary brand strategist and storyteller with deep expertise in creating authentic brand identities. She leads Meraki's vision — a boutique studio where business strategy meets narrative depth, and creative design translates into real business growth.",
    "Her work has shaped brand campaigns, visual guidelines, emotional film narratives, and product positioning for clients across India, the UK, and USA. She believes the most powerful brands aren't built; they're earned, one honest conversation at a time."
  ],
  expertise: [
    "Video Editing",
    "Film Direction",
    "Web Development",
    "Creative Strategy",
    "Team Leadership",
    "Brand Storytelling"
  ]
};

export const faqData = [
  {
    id: 1,
    question: "What is the typical timeline for a project?",
    answer: "Timelines vary by scope. A cinematic brand film usually takes 3-5 weeks, while a full e-commerce platform can take 6-10 weeks. We prioritize craft over speed, but we never miss a deadline."
  },
  {
    id: 2,
    question: "Do you handle both creative and technical aspects?",
    answer: "Yes. That is our core strength. We bridge the gap between high-end cinematic storytelling and robust digital engineering. You won't need separate agencies for your film and your software."
  },
  {
    id: 3,
    question: "What industries do you specialize in?",
    answer: "We work best with brands that value aesthetics and story — luxury, fashion, technology, and foundation/NGO sectors. If your brand needs to move hearts and minds, we are the right fit."
  },
  {
    id: 4,
    question: "Do you work with international clients?",
    answer: "Absolutely. We have successfully delivered projects for clients in the UK, UAE, and USA. Our process is designed for seamless remote collaboration."
  },
  {
    id: 5,
    question: "How do we get started?",
    answer: "Simply drop us an email or book a brief through our contact section. We'll set up a discovery call to understand your vision and see if we're a good match for each other."
  }
];

export const heroBackgroundImage =
  "https://images.unsplash.com/photo-1666698907743-c859bf13344c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxjaW5lbWElMjBsaWdodHN8ZW58MHx8fHwxNzc3NzEwOTI4fDA&ixlib=rb-4.1.0&q=85";

export const showreelImage =
  "https://images.pexels.com/photos/23384400/pexels-photo-23384400.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const technologies = [
  { name: "AWS", category: "Cloud" },
  { name: "React", category: "Frontend" },
  { name: "Next.js", category: "Frontend" },
  { name: "WordPress", category: "CMS" },
  { name: "JavaScript", category: "Language" },
  { name: "TypeScript", category: "Language" },
  { name: "HTML5", category: "Frontend" },
  { name: "CSS3", category: "Frontend" },
  { name: "Node.js", category: "Backend" },
  { name: "Tailwind CSS", category: "Design" },
  { name: "Figma", category: "Design" },
  { name: "MongoDB", category: "Database" },
  { name: "Docker", category: "DevOps" },
  { name: "Kubernetes", category: "DevOps" },
  { name: "Vercel", category: "Cloud" },
  { name: "Python", category: "Language" },
  { name: "Flutter", category: "Mobile" },
  { name: "Firebase", category: "Cloud" },
  { name: "GraphQL", category: "API" },
  { name: "PHP", category: "Backend" }
];

export const careers = {
  hero: {
    title: "Join the Meraki Collective",
    subtitle: "Where cinematic artistry meets digital rigour. We're looking for souls who leave a piece of themselves in their craft.",
  },
  values: [
    { title: "Craft over Speed", desc: "We don't rush perfection. We sweat the pixels and the frames until they sing.", image: "/images/value_craft_bg.png" },
    { title: "Radical Ownership", desc: "No micro-management. You own your project, your code, and your story.", image: "/images/value_ownership_bg.png" },
    { title: "Constant Curiosity", desc: "The intersection of film and tech is evolving. We learn something new every sprint.", image: "/images/value_curiosity_bg.png" }
  ],
  jobs: [
    { id: 1, title: "Senior Video Editor", type: "Full-time / Remote", location: "New Delhi / Remote", category: "Film", image: "/images/job_video_editor.png" },
    { id: 2, title: "Full Stack Developer", type: "Full-time", location: "New Delhi", category: "Tech", image: "/images/job_dev.png" },
    { id: 3, title: "Motion Designer", type: "Contract", location: "Remote", category: "Design", image: "/images/job_motion.png" },
    { id: 4, title: "Creative Strategist", type: "Full-time", location: "New Delhi", category: "Strategy", image: "/images/job_strategy.png" }
  ],
  process: [
    {
      step: "01",
      title: "Application Discovery",
      desc: "Find your role and share your soul. We look for portfolios that tell a story, not just a list of skills.",
      image: "/images/career_proc_app.png"
    },
    {
      step: "02",
      title: "Creative Synergy",
      desc: "A deep dive conversation with our founders. We're checking if our creative wavelengths and values align.",
      image: "/images/career_proc_synergy.png"
    },
    {
      step: "03",
      title: "Technical Deep Dive",
      desc: "Show us your craft in action. A real-world challenge designed to see how you solve problems under pressure.",
      image: "/images/career_proc_tech.png"
    },
    {
      step: "04",
      title: "The Collective Offer",
      desc: "Join the squad. Receive your official welcome to the Meraki Collective and start making history with us.",
      image: "/images/career_proc_offer.png"
    }
  ]
};
